import redfinIcon from "@/assets/redfin-icon.png";

export const RedfinIcon = ({ className = "h-6 w-6" }: { className?: string }) => {
  return (
    <img
      src={redfinIcon}
      alt="Redfin"
      className={className}
    />
  );
};
